export const NAV_LINKS = [
  { to: "/", label: "HOME" },
  { to: "/gallery", label: "GALLERY" },
  { to: "/about", label: "ABOUT" },
] as const;

export const GALLERY_PREFIXES = ["/gallery", "/compilations", "/content"];

export function getActiveNavIndex(pathname: string): number {
  return NAV_LINKS.findIndex((link) => {
    if (link.to === "/") return pathname === "/";
    if (link.to === "/gallery")
      return GALLERY_PREFIXES.some((p) => pathname.startsWith(p));
    return pathname.startsWith(link.to);
  });
}
